var React = require('react');

function Component (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0.322346 12.8297C0.322346 6.11232 5.76783 0.666834 12.4852 0.666834H22.6209C29.3382 0.666834 34.7837 6.11232 34.7837 12.8297V12.8297C34.7837 19.547 29.3382 24.9925 22.6209 24.9925H12.4852C5.76783 24.9925 0.322346 19.547 0.322346 12.8297V12.8297Z","fill":"#FFE500","key":0}),React.createElement("path",{"d":"M8.83633 11.7542H12.7263V7.72804H14.432V11.7542H18.3428V13.3853H14.432V17.4527H12.7263V13.3853H8.83633V11.7542Z","fill":"black","key":1}),React.createElement("path",{"d":"M24.648 18.5057H22.651V9.07008H19.3851V7.64545C20.3004 7.63168 21.0701 7.39769 21.6942 6.94346C22.3182 6.47546 22.7065 5.86983 22.8591 5.12654H24.648V18.5057Z","fill":"black","key":2})]);
}

Component.defaultProps = {"width":"35","height":"25","viewBox":"0 0 35 25","fill":"none"};

module.exports = Component;

Component.default = Component;
